import * as React from 'react';
import { Card } from '@blueprintjs/core';
import Button from '../../controls/forms/redesign/FormButton';

interface ILandmanExperienceCardProps {}

class LandmanExperienceCard extends React.Component<ILandmanExperienceCardProps> {
    onUpdateExperienceClick = () => {
        console.log('updating experiences');
    };

    public render() {
        const createCheckBadge = (name: string, isChecked: boolean) => {
            let css = 'lh-badge-small ';
            css += isChecked ? 'lh-icon-tick' : 'lh-icon-cross';

            return <span className={css}>{name}</span>;
        };

        return (
            <Card className="lh-half-width" elevation={1}>
                <h6>Experience</h6>
                Skills
                <div className="lh-badge-container">
                    {createCheckBadge('ROW', true)}
                    {createCheckBadge('Title Work', false)}
                    {createCheckBadge('Negotiation', true)}
                </div>
                Regions
                <div className="lh-badge-container">
                    {createCheckBadge('Eastern', true)}
                    {createCheckBadge('Mid-Con', false)}
                    {createCheckBadge('Texas', false)}
                    {createCheckBadge('Rockies', true)}
                </div>
                <Button text="View Resume" />
                <div style={{ marginTop: '.5em', textAlign: 'right' }}>
                    <Button intent="primary" onClick={this.onUpdateExperienceClick} size="medium" text="Update Experience" />
                </div>
            </Card>
        );
    }
}

export default LandmanExperienceCard;



// WEBPACK FOOTER //
// ./src/components/personnel/components/LandmanExperienceCard.tsx